var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var Queries = require("lib/shared/Queries");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

if ($wr.isDevelopment() && $wr.checkCustomEnv("local-matilda")) {
    var MatildaAPIClient = new (require("wr_apis/apis/matilda_api/node_package/src/index.js")).Client("localhost:3007", "http");
} else {
    var MatildaAPIClient = new (require("wr_apis/apis/matilda_api/node_package/src/index.js")).Client("matilda.whooosreading.org", "https");
}

var WhooosReadingServices = require("lib/web/WhooosReadingServices");

import { registerBatched } from "lib/actions/BatchingActions";

//////////////////////////////////////////////
// Logs //////////////////////////////////////
//////////////////////////////////////////////

export function fetchLogs({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getLogs,
			{ logs: [Schema.LOG] },
			{ params, embeds, page },
			{ reducer: "logs", loading: "index", cache }));
	}
}

export function deleteLog({ id }) {
	return (dispatch) => {
		APIClient.deleteLog(id);
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, logs: [id] });
	}
}

export function updateLog({ id, update }) {
	return (dispatch) => {
		APIClient.patchLog(id, { log: update });
		return dispatch({ type: ActionUtility.UPDATE_RECORDS, logs: [id], update: update });
	}
}

export function updateLogs({ ids, update }) {
	return (dispatch) => {
		var params = { log: update, update_ids: ids }
		APIClient.patchLog(ids[0], params)
		return dispatch({ type: ActionUtility.UPDATE_RECORDS, logs: ids, update: update });
	}
}

// Note plural
export function createLogs({ logs, embeds, query }) {
	var params = _.extend({}, query, { logs: logs });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postLogs,
			{ logs: [Schema.LOG] },
			{ embeds, params },
			{ reducer: "logs", loading: "create" }
		))
	}
}

//////////////////////////////////////////////
// Library ///////////////////////////////////
//////////////////////////////////////////////

export function fetchLibraryOnline({ cache }) {
	return (dispatch) => {
		var params = {}
		return dispatch(ActionUtility.fetchRecords(
			MatildaAPIClient.getLibraryOnline,
			{ books: [Schema.BOOK] },
			{ params },
			{ reducer: "books", loading: "index", cache }));
	}
}

export function fetchLibraryPlatforms({ cache }) {
	return (dispatch) => {
		var params = {}
		return dispatch(ActionUtility.fetchRecords(
			MatildaAPIClient.getLibraryPlatforms,
			{ platforms: [Schema.PLATFORM] },
			{ params },
			{ reducer: "platforms", loading: "index", cache }));
	}
}


//////////////////////////////////////////////
// Books /////////////////////////////////////
//////////////////////////////////////////////

// This is horrible I know - Greg 2020
export function fetchBookActivity({ filters, conditions, embeds, fetchDetails, userID, cache }) {
	conditions = conditions || {};
	var rangeKey = "activity:" + (conditions.startDate || "any") + ":" + (conditions.endDate || "any");

	return (dispatch, getState) => {
		var previousBooks = getState().books;

		function wrapBookActivity(record, recordKey) {
			if (recordKey == "books") {
				var wrappedBook = { text_id: record.text_id };

				var newRangeValue = _.omit(record, "text_id");;

				wrappedBook[rangeKey] = {};

				// If the book is already in the system for that time period
				// (maybe with different params), keep those values around
				var existingBook = previousBooks[record.text_id];
				if (existingBook && existingBook[rangeKey]) {
					Object.assign(wrappedBook[rangeKey], existingBook[rangeKey]);
				}

				Object.assign(wrappedBook[rangeKey], newRangeValue);

				return wrappedBook;
			} else {
				return record;
			}
		}

		var params = Queries.toQuery(filters, conditions);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getBooks,
			{ books: [Schema.BOOK] },
			{ params, embeds },
			{ reducer: "books", loading: "index", cache, mapRecordF: wrapBookActivity }
		)).then((recieveAction) => {

			if (fetchDetails && recieveAction) {
				// This is prehaps a little hacky...
				// We're going to intercept the action receiving the books, 
				// grab the IDs, and run them through the fetchBooks action
				// as a side effect so we can preemptively load in the titles
				// and (importantly) the text_variety, which we may need for filtering

				dispatch(ActionUtility.setLoadingRecords("books", "index"))

				var ids = _.pluck(recieveAction.books, "text_id");
				if (ids.length > 0) {
					dispatch(fetchBooks({ ids, userID })).then(() => {
						return dispatch(ActionUtility.clearLoadingRecords("books"));
					})
				} else{
					return dispatch(ActionUtility.clearLoadingRecords("books"));					
				}
			}

			return recieveAction;
		});
	}
}

export function fetchSingleBookActivity({ id, embeds, query, cache, conditions, filters, userID }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		_.extend(params, query);

		return dispatch(ActionUtility.fetchRecord(
			APIClient.getBook,
			id,
			{ book: Schema.BOOK },
			{ params, embeds },
			{ reducer: "books", loading: id, cache }
		));
	}
}

export function batchFetchBook({ id, userID }) {
	return registerBatched("books", [id], (ids) => fetchBooks({ ids, userID }));
}

// Usually we will want to use batchFetchBook or fetchBookActivity instead of fetchBooks directly
export function fetchBooks({ ids, userID, query }) {
	if (userID == undefined) {
		var params = { ...query, keys: ids.join(",") }
	} else {
		var params = { ...query, keys: ids.join(",") , user_id: userID }
	}

	return (dispatch) => {
		return MatildaAPIClient.postScopedLookup("text_id", params).then((data) => {
			// Adjust for the fact that we allow text_id to be mapped to different books
			// by replacing the ID of the book with the ID originally requested...
			var dataResults = _.omit(data.results, "_cached_at");
			var results = _.mapObject(dataResults, (book, requestedID) => {
				return _.extend({}, book, { text_id: requestedID });
			});

			dispatch(ActionUtility.receiveRecords(_.values(results), [Schema.BOOK]));
		});

	}
}

// When we want to fetch a single book synchronously
export function fetchBookSynchronously({ id, userID }) {
	var params = {}
	if (userID != undefined) {
		params = {user_id: userID}
	}
	return (dispatch) => {
		return MatildaAPIClient.getScopedBook("text_id", id, params).then((data) => {
			// Adjust for the fact that we allow text_id to be mapped to different books
			// by replacing the ID of the book with the ID originally requested...
			var book = _.extend({}, data.book, { text_id: id });
			return dispatch(ActionUtility.receiveRecords(book, Schema.BOOK));
		});

	}
}

export function invalidateBookCache({}) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.INVALIDATE_CACHE, books: true })
	}
}

export function localUpdateBook({id, update}) {
	update = $wr.sanitizeObject(update)
	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, books: [id], update: update })
		return Promise.resolve();
	}
}

export function createOverrideUpdateBook({ override, update }) {
    return (dispatch) => {
        dispatch({ type: ActionUtility.UPDATE_RECORDS, books: [override.instance_id], update: update });
        return MatildaAPIClient.postOverrides({ override: override })
    }
}

export function createBook({ book }) {
	var params = { book };

	return (dispatch) => {		
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postBooks,
			{ book: Schema.BOOK },
			{ params },
			{ reducer: "books", loading: "create" }
		))
	}
}


//////////////////////////////////////////////
// Reading Levels ////////////////////////////
//////////////////////////////////////////////

export function fetchReadingLevels({ filters, conditions, embeds, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		dispatch(ActionUtility.fetchRecords(
			APIClient.getReadingLevels,
			{ reading_levels: [Schema.READING_LEVEL] },
			{ params, embeds },
			{ reducer: "readingLevels", loading: "index", cache }));
	}
}





// WEBPACK FOOTER //
// ./modules/lib/actions/ReadingActions.js